import { FC } from "react"
import retrieveAxiosErr from "@/utils/retrieveAxiosErr"
import { useSafeSetState } from "ra-core"
import { SupportedResources } from "@/dataProvider/tools"
import { useResourceRegister } from "@/utils/resourceRegister"
import { ResetPasswordValidationResult } from "@/gen/api/user"
import { useLocation, Link as RouterLink } from "react-router-dom"
import { parse, pickQueries } from "@/utils/queryStringWrapper"
import { useEffect } from "react"
import LayoutPlain from "../LayoutPlain"
import { Button } from "@mui/material"
import LoadingScreen from "@/components/LoadingScreen"
import ClientError from "../../ClientError"
import CreateOrEdit from "@/controller/CreateOrEdit"
import { useSimpleSaveAction } from "@/controller/SaveContextProvider"
import PasswordRecoverySmsValidate from "./PasswordRecoverySmsValidate"


const resource: SupportedResources = 'resetpassword-validate'


const ResetPasswordCollect: FC = (props) => {
  useResourceRegister({ name: resource })

  // const validateResult = useSelector<ReduxState, any>(store => store.admin.resources[resource]?.data[-1])
  return (
    <CreateOrEdit
      resource={resource} basePath=""
      id="email"
      record={{id: 'email'} as any}
    >
      <ResetPasswordCollectCater {...props} />
    </CreateOrEdit>
  )
}

const ResetPasswordCollectCater: FC = (props) => {
  const save = useSimpleSaveAction()
  const location = useLocation()

  const [ states, setStates ] = useSafeSetState({
    code: null as string|null,
    cid: null as string|null,
    error: null as any,
    validateResult: undefined as ResetPasswordValidationResult | undefined,
  })

  useEffect(() => {
    if (!location.search) { return }
    setStates(v => {
      if (v.code) { return v }
      const pick = pickQueries(parse(location.search))
      const code = pick('code') || 'never'
      const cid = pick('cid') || 'never'
      if (code) {
        const sendValidate = save
        sendValidate({ code, cid }, {
          onSuccess: ({data}: {data:{data:ResetPasswordValidationResult}}) => {
            setStates(v1 => ({ ...v1, validateResult: data.data }))
          },
          onFailure: (err:any) => {
            setStates(v1 => ({ ...v1, error: err }))
          }
        })
      }
      return { ...v, code, cid, }
    })
  }, [location.search, save, setStates])


  // email was not decoded by backend from code yet
  if (!states.validateResult?.email) {
    // or, the code is invalid/expired
    if (states.error) {
      return (
        <LayoutPlain>
          <ClientError 
            errorNumber={400}
            errorMsg={retrieveAxiosErr(states.error)}
            shortTitle="Password Recovery"
            escapeEntry={
              <Button
                color="primary"
                component={RouterLink}
                to="/login"
                variant="outlined"
              >
                Take me to Sign In properly
              </Button>
            }
          />
        </LayoutPlain>
      )
    } else {
      return (
        <LoadingScreen />
      )
    }
  }

  return (
    <PasswordRecoverySmsValidate email={states.validateResult.email} cid={states.cid!} codeJwt={states.code!} />
  )
}

export default ResetPasswordCollect;